export default "__VITE_ASSET__B83NQr3q__"